/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ClientMessageTypeEnum } from './clientMessageTypeEnum';


/**
 * Request for creation new theme
 */
export interface CreateThemeRequest { 
    /**
     * User crm id
     */
    toUserId: number;
    /**
     * Theme title
     */
    title: string;
    type: ClientMessageTypeEnum;
    /**
     * Message
     */
    message: string;
    /**
     * Ids of attachments in cache
     */
    attachmentsGuids?: Array<string> | null;
}

